export const name = 'applePay' as const
